import { render } from "./AppProductionSection.vue?vue&type=template&id=ea2ae8b8&scoped=true"
import script from "./AppProductionSection.vue?vue&type=script&lang=js"
export * from "./AppProductionSection.vue?vue&type=script&lang=js"

import "./AppProductionSection.vue?vue&type=style&index=0&id=ea2ae8b8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\danil\\PersonalData\\WebsiteDevelopment\\GitHub\\biorobot-factory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea2ae8b8"]])

export default __exports__